// Auto-generated file - do not edit manually
export const LOCALE_HASH = '36d285b7';
